// extracted by mini-css-extract-plugin
export default {"resetButton":"nF7KTAZ","selectedUser":"pzakIzV","removeButton":"cXo80Ng","isDeactivatedBadge":"zEalP6j"};